var map = {
	"./activities.png": "84f3",
	"./calendar.png": "401b",
	"./certificates.png": "3b5f",
	"./dashboard.png": "67e5",
	"./email.png": "8608",
	"./facebook.png": "5bf0",
	"./files.png": "1e89",
	"./instagram.png": "79f6",
	"./logo.png": "4ffd",
	"./pdf.png": "77ef",
	"./people.png": "f87f",
	"./private-files.png": "2b63",
	"./teams.png": "29d3",
	"./user.png": "0f71",
	"./whatsapp.png": "8c62",
	"./youtube.png": "f599"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";